export default "__VITE_ASSET__CMpEqNUb__"